import { TitleFilterState } from './store/title.types';

export const titleFilterHash = (option: TitleFilterState['title']): string => option;
